export const groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
  list.reduce((previous, currentItem) => {
    const group = getKey(currentItem)
    if (!previous[group]) previous[group] = []
    previous[group].push(currentItem)
    return previous
  }, {} as Record<K, T[]>)

export const uniqueBy = (array: any[], key: string) => array.filter((thing, i, arr) => {
  return arr.indexOf(arr.find(t => t[key] === thing[key])) === i
})

export const move = (items: any[], fromIndex: number, toIndex: number) => {
  const element = JSON.parse(JSON.stringify((items[fromIndex])))
  const _items = JSON.parse(JSON.stringify((items)))

  _items.splice(fromIndex, 1)
  _items.splice(toIndex, 0, element)

  return _items
}
